import React, { useEffect, useState } from "react";
import { InlineWidget } from "react-calendly";


// Import router from next
import { useNavigate } from "react-router-dom";

// testing token
// const token = 'Bearer '+'aw2a2seyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjQ5MDgzNzgxLCJqdGkiOiJiZTZmNjU1MS1iNWYwLTQ3NWQtYjJhNS04ZGU3MDRlMDg2YWQiLCJ1c2VyX3V1aWQiOiJERUVETUJZRzVZQUJNUDdYIn0.Qj6DrIhpqQnwn8n-YpT0bixkl9TBUCtC-hn-E6t97Bs'; 

// live token
const token = 'Bearer '+'eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjQ5MDg1NzE0LCJqdGkiOiJkYjhhMDI2NS03Nzk2LTRiZTYtYjdjZi1mM2NhY2YxYzlmNjciLCJ1c2VyX3V1aWQiOiJERUVETUJZRzVZQUJNUDdYIn0.q2St3KwElJAUq3gRAxBKM1mD88I2C80ccrw4bAi3CWI'; 

function Calendly({onSchedule, calendlyURL}) {

	const [userEmail, setUserEmail] = useState('');
	const [url, setUrl] = useState('');

	useEffect(() => {
		console.log(calendlyURL);
		setUrl(calendlyURL);
	},[url,calendlyURL]);

	useEffect(async () => {
		window.addEventListener(
			'click',
			 (e) => {
				if (isCalendlyEvent(e)) {
					if(e.data.payload.event){
                        onSchedule(e.data.payload)
					}
				}
			}
		);

		var session_token = JSON.parse(localStorage.getItem("supabase.auth.token")) || '';
		setUserEmail(session_token ? session_token.currentSession.user.email : '');
		
	}, []);

    function isCalendlyEvent(e) {
		return e.data.event &&
			e.data.event.indexOf('calendly') === 0;
	};

	return (
		<div className="h-full">
				{url &&
				<InlineWidget url={`${url}?hide_gdpr_banner=1`} 
				styles={{height: "100vh"}}
				/>
				}
            </div>
)
};

export default Calendly;